// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"c5c5461508dddbf5cd05","293":"6fba96a469055275e04d"}[chunkId] + ".js";
};